import { ReactElement, useMemo, useState } from "react";
import { InventoryItemContainerProps } from "./components/InventoryItemSlot/InventoryItemContainer";
import PageFramework from "../../common/components/layout/PageFramework/PageFramework";
import { useSearchParams } from "react-router-dom";
import CharacterSheetContainer from "./components/CharacterSheet/CharacterSheetContainer";
import NoCharacterContainer from "./NoCharacterContainer";
import Icon from "../../common/components/Icon/Icon";
import InventoryItemTransferContext from "../../utils/sys/InventoryItemTransferContext";
import DiceDrawer from "./components/DiceDrawer/DiceDrawer";
import type { KeyValuePair } from "../../utils/sys/KeyValuePair";

import diceRollLogo from "../../assets/images/common/svg/dice_logo.svg";

import "./CharacterPage_style.css";

export default function CharacterPage(): ReactElement {
    const [searchParams, _] = useSearchParams();
    const [
        inventoryItemTransferTargetItemContainer,
        setInventoryItemTransferTargetItemContainer,
    ] = useState<InventoryItemContainerProps | null>(null);
    const [isDiceDrawerVisible, setIsDiceDrawerVisible] = useState<boolean>(false);
    const [diceCounts, setDiceCounts] = useState<ReadonlyArray<KeyValuePair<number, number>>>([]);

    const characterIDs = useMemo((): Array<number> => {
        return searchParams
            .getAll("id")
            .flatMap((id) => {
                const numID = Number.parseInt(id);

                return Number.isNaN(numID) ? [] : numID;
            })
            .filter((_, index) => index < 5);
    }, [searchParams]);

    const inventoryItemTransferContext = {
        transferTargetItemContainer: inventoryItemTransferTargetItemContainer,
        setTransferTargetItemContainer:
            setInventoryItemTransferTargetItemContainer,
    };

    return (
        <PageFramework noPadding={characterIDs.length > 0}>
            <div className="dice-drawer-button">
                <Icon src={diceRollLogo} size={36} onClick={() => {setIsDiceDrawerVisible(!isDiceDrawerVisible);}} />
            </div>
            <InventoryItemTransferContext.Provider
                value={inventoryItemTransferContext}
            >
                {characterIDs.length === 0 && <NoCharacterContainer />}
                {characterIDs.length > 0 &&
                    characterIDs.map((characterID) => (
                        <CharacterSheetContainer
                            key={`character-sheet-container-${characterID}`}
                            characterID={characterID}
                            applyDocumentTitle={characterIDs.length === 1}
                        />
                    ))}
            </InventoryItemTransferContext.Provider>
            <DiceDrawer isVisible={isDiceDrawerVisible} diceCounts={diceCounts} onDiceCountsChange={setDiceCounts} onClose={() => {setIsDiceDrawerVisible(false);}} />
        </PageFramework>
    );
}
